"use client";

import { Button } from "@heroui/button";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
} from "@heroui/dropdown";
import { useLocale } from "next-intl";
import { MdOutlineLanguage } from "react-icons/md";

import { useRouter, usePathname } from "@/i18n/navigation";
import { routing, languages } from "@/i18n/routing";
import { logEvent } from "@/services/analytics";
import { getKeyString } from "@/utils/common";

export default function LanguageSwitch() {
  const locale = useLocale();
  const router = useRouter();
  const pathname = usePathname();

  return (
    <Dropdown>
      <DropdownTrigger>
        <Button
          className="px-0"
          size="sm"
          startContent={<MdOutlineLanguage size={20} />}
          variant="light"
        >
          {locale.toUpperCase()}
        </Button>
      </DropdownTrigger>
      <DropdownMenu aria-label="Languages">
        {routing.locales.map(locale_ => (
          <DropdownItem
            key={locale_}
            onClick={() => {
              router.replace(pathname, { locale: locale_ });
              logEvent(getKeyString(`language_switch_${locale_}`), {
                from_locale: locale,
                to_locale: locale_,
                page: pathname,
              });
            }}
          >
            {languages[locale_ as keyof typeof languages]}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
}
